/**
 * Standard IBAN mod-97 checksum validation (ISO 7064).
 * Reimplemented locally instead of pulling in mobile's `iban-ts` package for
 * a single validator function.
 * @param {string} value
 * @returns {boolean}
 */
export const isValidIban = (value) => {
  const iban = String(value || "").replace(/\s+/g, "").toUpperCase();

  // Basic format: 2 letters (country) + 2 digits (check) + up to 30 alphanumerics.
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(iban)) return false;

  // Move the first 4 characters to the end, then convert letters to numbers
  // (A=10, B=11, ..., Z=35) per the standard IBAN checksum algorithm.
  const rearranged = iban.slice(4) + iban.slice(0, 4);
  const numeric = rearranged.replace(/[A-Z]/g, (ch) => String(ch.charCodeAt(0) - 55));

  // mod 97 on a large numeric string, done in chunks to avoid precision loss.
  let remainder = numeric;
  while (remainder.length > 2) {
    const chunk = remainder.slice(0, 9);
    remainder = String(parseInt(chunk, 10) % 97) + remainder.slice(chunk.length);
  }

  return parseInt(remainder, 10) % 97 === 1;
};
